import MessageThreadHeaderContainer from './MessageThreadHeaderContainer';

export default MessageThreadHeaderContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadHeaderContainer/index.js